import { Col, Container } from "react-bootstrap";
import "../css/imgFigures.css";
import { useEffect, useState } from "react";
import ApiService from "../../../../services/api";

const Imgfigures = () => {
  const [img, setImg] = useState({});
  const [Loading, setLoading] = useState(true);

  const fetchImg = async () => {
    const herosList = await ApiService.getSlidersHero();
    setImg(herosList);
    setLoading(false);
  };

  useEffect(() => {
    fetchImg();
  }, []);

  if (Loading) {
    return;
  }
  return (
    <Container fluid className="p-0 m-0">
      <Col className="container-black-imgFigures py-3">
        <Container className="container_img">
          <img
            className="w-100 object-fit-cover"
            src={img[7].img}
            alt=""
          ></img>
        </Container>
      </Col>
    </Container>
  );
};
export default Imgfigures;
